import { createStyle } from "@gluestack-style/react";

export const BaseIcon = createStyle({
  color: "$backgroundLight800",
  _dark: {
    color: "$backgroundDark400",
  },
  variants: {
    size: {
      "2xs": {
        h: "$3",
        w: "$3",
        props: {
          size: 12,
        },
      },
      xs: {
        h: "$3.5",
        w: "$3.5",
        props: {
          size: 15,
        },
      },
      "2sm": {
        h: "$4.5",
        w: "$4.5",
        props: {
          size: 18,
        },
      },
      sm: {
        h: "$6",
        w: "$6",
        props: {
          size: 24,
        },
      },
      md: {
        h: "$7",
        w: "$7",
        props: {
          size: 32,
        },
      },
      lg: {
        h: "$8",
        w: "$8",
        props: {
          size: 48,
        },
      },
      xl: {
        h: "$9",
        w: "$9",
        props: {
          size: 56,
        },
      },
      "2xl": {
        h: "$10",
        w: "$10",
        props: {
          size: 72,
        },
      },
    },
  },
  // defaultProps: {
  //   size: 'md',
  // },
});

export const Icon = createStyle({
  props: {
    size: "md",

    fill: "none",
  },
  color: "$backgroundLight800",
  _dark: {
    color: "$backgroundDark400",
  },
});
